import { Box } from '@mantine/core';

export function ChatScrollBlur({ dark }: { dark?: boolean }) {
  const fadeColor = dark ? '70, 70, 70' : '255, 255, 255';

  return (
    <Box
      pos="absolute"
      top={0}
      left={0}
      w="100%"
      h={64}
      style={{
        background: `linear-gradient(to bottom, rgba(${fadeColor}, 0.8) 0%, rgba(${fadeColor}, 0) 100%)`,
        zIndex: 1,
        pointerEvents: 'none',
      }}
    />
  );
}
